import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Formato moneda Panamá (B/. = USD paridad fija). */
export function money(n: number): string {
  return `B/. ${n.toLocaleString("es-PA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** uuid v4 para idempotencia de ventas/abonos/recepciones (offline-safe). */
export function uuid(): string {
  return crypto.randomUUID();
}

/** Porcentaje ITBMS por enum (espejo de app.itbms_pct en BD). */
export function itbmsPct(rate: string | null | undefined): number {
  switch (rate) {
    case "rate_7":  return 0.07;
    case "rate_10": return 0.10;
    case "rate_15": return 0.15;
    default:        return 0;        // exento / rate_0 / null
  }
}

/** Redondeo fiscal DGI §8.4.1: half-up a 3 decimales, luego a 2 (espejo de app.fiscal_round). */
export function fiscalRound(n: number): number {
  const x = Math.round(n * 1000) / 1000;
  return Math.round(x * 100) / 100;
}
